import TreeCategoryList from "./TreeCategoryList";

export const CategorySection = ({
  category_key,
  loading,
  title,
  data,
  hasClicked,
  onArticleClick
}) => {
  const hasData = Array.isArray(data) && data.length > 0;

  // 🚫 User hasn’t clicked yet → show nothing
  if (!hasClicked) return null;

  return (
    <section className="mt-3 pt-3 border-t">
      {loading && (
        <p className="text-gray-500">Loading articles…</p>
      )}

      {!loading && !hasData && (
        <p className="text-gray-400 italic">
          No articles found in{" "}
          <span className="font-medium">{title}</span>
        </p>
      )}

      {hasData && (
        <section className="px-4 sm:px-6 lg:px-10">
          <h2 className="text-xl font-semibold text-gray-800">
            Articles in{" "}
            <span className="text-indigo-600">{title}</span>
          </h2>

          <TreeCategoryList
            data={data}
            categoryName={title}
            category_key={category_key}
            onArticleClick={onArticleClick}
          />
        </section>
      )}
    </section>
  );
};

